<template>
  <div class="delete-confirm-button-container" @click="showConfirmDialog()">
    <b-button :variant="variant" :class="{'full-width': fullWidth}" id="archiveBtn">
      <icon :name="iconName" scale="1" id="icon" v-if="iconName != 'archive'"></icon>
      <svg v-else id="archive" viewBox="0 0 22 22"><path class="st3" d="M21,0H1C0.45,0,0,0.45,0,1v5.41c0,0.55,0.45,1,1,1h1.16V21c0,0.55,0.45,1,1,1h15.69c0.55,0,1-0.45,1-1V7.41H21 c0.55,0,1-0.45,1-1V1C22,0.45,21.55,0,21,0z M17.84,20H4.16V7.41h13.69V20z M20,5.41h-1.16H3.16H2V2h18V5.41z"/><path class="st3" d="M8.21,12.7h5.59c0.55,0,1-0.45,1-1s-0.45-1-1-1H8.21c-0.55,0-1,0.45-1,1S7.65,12.7,8.21,12.7z"/></svg>
      <div>{{ title }}</div>
    </b-button>

    <!-- Modal -->
    <b-modal v-if="isModal" v-model="confirmDeletion" hide-footer centered :title="message">
      <p>Êtes-vous sûr(e) de vouloir effectuer cette action ?</p>
      <p><strong>Attention!</strong> Cette action est irreversible.</p>
      <div class="confirm-actions">
        <b-button variant="danger" @click.stop.prevent="deleteConfirm($event, true)">
          Confirmer
        </b-button>
        <b-button variant="info" @click.stop.prevent="deleteConfirm($event, false)">
          Annuler
        </b-button>
      </div>
    </b-modal>

    <!-- Absolute -->
    <div class="absolute-confirm-deletion" v-if="!isModal && confirmDeletion">
      <h3>{{ title }}</h3>
      <p>Êtes-vous sûr(e) de vouloir effectuer cette action ?</p>
      <p><strong>Attention!</strong> Cette action est irreversible.</p>
      <div class="confirm-actions">
        <b-button variant="danger" @click="deleteConfirm($event, true)">
          Confirmer
        </b-button>
        <b-button variant="info"
                  @click="deleteConfirm($event, false)">
          Annuler
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeleteConfirmButton',
  props: {
    message: {
      type: String,
      default: 'Supprimer définitivement',
    },
    title: {
      type: String,
      default: '',
    },
    isModal: {
      type: Boolean,
      default: true,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    iconName: {
      type: String,
      default: 'archive',
    },
    variant: {
      type: String,
      default: 'danger',
    },
    styleBtn: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      confirmDeletion: false,
    };
  },
  methods: {
    showConfirmDialog() {
      this.confirmDeletion = true;
    },
    deleteConfirm(event, confirmed) {
      // The deletion is not confirmed return and close question
      if (confirmed) {
        this.$emit('confirmed');
      } else {
        this.$emit('canceled');
      }
      this.confirmDeletion = !this.confirmDeletion;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .absolute-confirm-deletion {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: white;
    z-index: 1;
    padding: 20px;
  }

  .full-width {
    width: 100% !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  #archiveBtn {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 8px 30px;

    &:hover {
      #archive {
        fill: #C74949;
      }
    }

    #archive {
      fill: white;
      width: 22px;
      margin-right: 10px;
    }
  }

  #icon {
    margin-right: 10px;
  }

  .confirm-actions {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    margin-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/button/DeleteConfirmButton.vue